import { z } from "zod";

// eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
export const SealView = z.object({
    sealedUntil: z.string(),
});

export type SealView = z.infer<typeof SealView>;
